import React from "react";
import PropTypes from "prop-types";

import Button from "../../../../component/button/Button";
import HeaderTag from "../../../../component/smallComponents/HeaderTag";
import SpinnerButton from "../../../../component/spinner/SpinnerButton";
import TextInput from "../../../../component/input/TextInput";

const ImageInput = ({
  faceType,
  onSubmit,
  userLoading,
  userImagePreview,
  FaceImageComponents,
  setUserImagePreview
}) => (
  <form onSubmit={onSubmit}>
    <HeaderTag
      type="h4"
      title="PLEASE ONLY SELECT FACE IMAGE [ONLY FACE] !!"
      isClassName={true}
      className="text-danger"
    />
    <div className="row mb-2">
      <div className="col-md-3 mt-4 col-xl-3 col-lg-3">
        <TextInput
          type="file"
          required={true}
          textWhite={false}
          file={true}
          htmlFor="userImage"
          label={`Add ${faceType} Side Photo`}
          onChange={setUserImagePreview}
        />
      </div>
      <div className="col-md-3 col-xl-3 col-lg-3">
        <img
          src={FaceImageComponents[faceType]}
          className="img-thumbnail"
          style={{ height: "150px", width: "150px" }}
        />
      </div>
      <div className="col-md-3 col-xl-3 col-lg-3">
        <img
          src={userImagePreview}
          className="img-thumbnail"
          style={{ height: "150px", width: "150px" }}
        />
      </div>
      <div className="form-group text-center col-sm-3 mt-5 col-xl-3 col-lg-3">
        {userLoading ? (
          <SpinnerButton />
        ) : (
          <Button
            title={faceType}
            type="submit"
            className="btn text-white btn-block btn-dark"
            isBackgroundColor={false}
            icon="mdi mdi-plus-circle-outline mr-2"
          />
        )}
      </div>
    </div>
  </form>
);

ImageInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  faceType: PropTypes.string.isRequired,
  userLoading: PropTypes.bool.isRequired,
  userImagePreview: PropTypes.string,
  setUserImagePreview: PropTypes.func.isRequired,
  FaceImageComponents: PropTypes.object.isRequired
};

export default ImageInput;
